var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "card", attrs: { "max-width": 900 } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("copy-views")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [_c("w-col", [_vm._v(" " + _vm._s(_vm.instruction) + " ")])],
            1
          ),
        ],
        1
      ),
      _vm.selectSourceDossierVisible
        ? _c(
            "w-scroll-view",
            { staticClass: "grow", attrs: { tag: "w-list" } },
            _vm._l(_vm.dossiers, function (dossier) {
              return _c(
                "w-list-item",
                {
                  key: dossier.ID,
                  on: {
                    click: function ($event) {
                      return _vm.selectSourceDossier(dossier)
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [
                      dossier == _vm.sourceDossier
                        ? _c("w-fa", { attrs: { icon: "check" } })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("w-list-item-text", [_vm._v(_vm._s(dossier.name))]),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.selectSourceVisible
        ? _c(
            "w-scroll-view",
            { staticClass: "grow", attrs: { tag: "w-list" } },
            _vm._l(_vm.users, function (user) {
              return _c(
                "w-list-item",
                {
                  key: user.ID,
                  on: {
                    click: function ($event) {
                      return _vm.selectSourceUser(user)
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [
                      user == _vm.sourceUser
                        ? _c("w-fa", { attrs: { icon: "check" } })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(user.getUserString())),
                  ]),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm.selectTargetsVisible
        ? _c(
            "w-scroll-view",
            { staticClass: "grow", attrs: { tag: "w-list" } },
            _vm._l(_vm.availableTargetUsers, function (user) {
              return _c(
                "w-list-item",
                {
                  key: user.ID,
                  on: {
                    click: function ($event) {
                      return _vm.selectTargetUser(user)
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [
                      _vm.targetUserSelected(user)
                        ? _c("w-fa", { attrs: { icon: "check" } })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(user.getUserString())),
                  ]),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _c("app-users-select-views", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selectViewsVisible,
            expression: "selectViewsVisible",
          },
        ],
        staticClass: "grow",
        attrs: {
          "overwrite-existing-views": _vm.overwriteExistingViews,
          "user-id": _vm.sourceUserId,
          "dossier-id": _vm.sourceDossier.id,
          "selected-views": _vm.selectedViews,
        },
        on: {
          "update:overwriteExistingViews": function ($event) {
            _vm.overwriteExistingViews = $event
          },
          "update:overwrite-existing-views": function ($event) {
            _vm.overwriteExistingViews = $event
          },
        },
      }),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: _vm.previousButtonIcon },
              on: {
                click: function ($event) {
                  return _vm.previousClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.previousButtonText) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                disabled: _vm.nextButtonDidsabled,
                icon: _vm.nextButtonIcon,
              },
              on: {
                click: function ($event) {
                  return _vm.nextClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.nextButtonText) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }